<div class="mb-3">
    <h2>{{ getTitle() }}</h2>
    <p *ngIf="textContent === ''">
        {{'START.HEADER.MESSAGE_LINE_1' | translate }}<br>
        {{'START.HEADER.MESSAGE_LINE_2' | translate }}
    </p>
    <p *ngIf="textContent !== ''">
        {{textContent | translate}}
        <a 
            [href]="anchorHref"
            target="_parent">
            {{ anchorText }}
        </a>
    </p>
    <div class="d-flex gap-3">
        <button id="es" class="btn btn-primary fw-bold"
            *ngIf="!(this.translationService.currentLanguage === lang.spanish)"
            (click)="useLanguage(lang.spanish)">
            en Español
        </button>
        <button id="en" class="btn btn-primary fw-bold"
            *ngIf="!(this.translationService.currentLanguage === lang.english)"
            (click)="useLanguage(lang.english)">
            in English
        </button>
        <button id="zh" class="btn btn-primary"
            *ngIf="!(this.translationService.currentLanguage === lang.chinese)"
            (click)="useLanguage(lang.chinese)">
            中文
        </button>
    </div>
</div>